(() => {
  const configuration = document.getElementById('ls-giveaway-language-config');
  if (!configuration) return;
  const config = JSON.parse(configuration.textContent);
  const language = config.language;
  const allowedId = config.forms[language];
  const ids = new Set(Object.values(config.forms));
  const duration = 7 * 24 * 60 * 60 * 1000;
  const shownKey = 'lukesolve_haaland_shown_at';
  const submittedKey = 'lukesolve_haaland_submitted';
  const changeKey = 'lukesolve_language_changed_at';
  const arrived = Date.now();
  const prompt = document.getElementById('ls-language-prompt');
  const terminal = new Set(['cooldown', 'no-primary-language', 'population-threshold', 'no-location-result', 'location-unavailable', 'not-english']);
  let waitedForPrompt = false;
  let readyAt = arrived + 15000;
  let shownInPage = false;
  let submittedInPage = false;
  let remembered = false;
  const wrappers = new Map();
  const read = key => {
    let local = '';
    try { local = localStorage.getItem(key) || ''; } catch {}
    const prefix = key + '=';
    const cookie = document.cookie.split('; ').find(value => value.startsWith(prefix));
    if (key === shownKey || key === changeKey) return Math.max(Number(local) || 0, cookie ? Number(cookie.slice(prefix.length)) || 0 : 0);
    return local || (cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '');
  };
  const write = (key, value) => {
    try { localStorage.setItem(key, String(value)); } catch {}
    try { document.cookie = `${key}=${encodeURIComponent(value)}; Max-Age=604800; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`; } catch {}
  };
  const recent = () => {
    const timestamp = read(shownKey);
    return timestamp > 0 && Date.now() - timestamp < duration;
  };
  const blockedByHistory = () => !shownInPage && (recent() || Boolean(read(submittedKey)));
  const pendingPrompt = () => {
    if (!prompt || language !== 'en') return false;
    if (prompt.open || prompt.dataset.switching === 'true') return true;
    if (terminal.has(prompt.dataset.status)) return false;
    if (prompt.dataset.status === 'shown' && !prompt.open) return false;
    return Date.now() - arrived < 125000;
  };
  const eligible = () => {
    if (!allowedId || /\/(cart|checkout|account)(\/|$)/.test(location.pathname)) return false;
    if (blockedByHistory()) return false;
    if (pendingPrompt()) {
      waitedForPrompt = true;
      readyAt = Date.now() + 15000;
      return false;
    }
    if (waitedForPrompt) {
      readyAt = Math.max(readyAt, Date.now() + 15000);
      waitedForPrompt = false;
    }
    readyAt = Math.max(readyAt, Number(read(changeKey)) + 15000);
    return document.visibilityState === 'visible' && Date.now() >= readyAt;
  };
  const rootFor = form => {
    let root = form;
    for (let parent = form.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
      if (getComputedStyle(parent).position === 'fixed' || parent.getAttribute('role') === 'dialog') root = parent;
    }
    return root;
  };
  const hold = root => {
    if (wrappers.has(root)) return;
    wrappers.set(root, {visibility:root.style.visibility, pointerEvents:root.style.pointerEvents, inert:root.inert, ariaHidden:root.getAttribute('aria-hidden')});
    root.style.visibility = 'hidden';
    root.style.pointerEvents = 'none';
    root.inert = true;
    root.setAttribute('aria-hidden', 'true');
  };
  const release = root => {
    const saved = wrappers.get(root);
    if (!saved) return;
    root.style.visibility = saved.visibility;
    root.style.pointerEvents = saved.pointerEvents;
    root.inert = saved.inert;
    if (saved.ariaHidden === null) root.removeAttribute('aria-hidden'); else root.setAttribute('aria-hidden', saved.ariaHidden);
    wrappers.delete(root);
  };
  const close = root => {
    const closeButton = Array.from(root.querySelectorAll('button')).find(button => /close (dialog|form)/i.test(button.getAttribute('aria-label') || ''));
    if (closeButton) closeButton.click();
  };
  const inspect = () => {
    const ready = eligible();
    for (const form of document.querySelectorAll('form[data-testid]')) {
      const id = (form.getAttribute('data-testid') || '').replace('klaviyo-form-', '');
      if (!ids.has(id)) continue;
      const root = rootFor(form);
      form.lang = Object.keys(config.forms).find(key => config.forms[key] === id) || 'en';
      form.dir = ['ar', 'fa'].includes(form.lang) ? 'rtl' : 'ltr';
      if (id !== allowedId || blockedByHistory() || submittedInPage) {
        hold(root);
        close(root);
        continue;
      }
      if (!ready) {
        hold(root);
        continue;
      }
      release(root);
      const visible = form.checkVisibility ? form.checkVisibility({checkOpacity:true, checkVisibilityCSS:true}) : getComputedStyle(form).visibility === 'visible';
      if (!shownInPage && visible && form.getBoundingClientRect().width && form.getBoundingClientRect().height) {
        shownInPage = true;
        if (!remembered) {
          write(shownKey, Date.now());
          remembered = true;
        }
      }
    }
    for (const [root] of wrappers) if (!root.isConnected) wrappers.delete(root);
    configuration.dataset.status = blockedByHistory() ? 'cooldown' : ready ? 'ready' : 'waiting';
  };
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (!ids.has(detail.formId)) return;
    if (detail.type === 'submit' && detail.formId === allowedId && shownInPage) {
      submittedInPage = true;
      write(submittedKey, '1');
    }
    inspect();
  });
  window.addEventListener('storage', event => { if ([shownKey, submittedKey, changeKey].includes(event.key)) inspect(); });
  document.addEventListener('visibilitychange', inspect);
  if (prompt) prompt.addEventListener('close', () => { readyAt = Date.now() + 15000; waitedForPrompt = false; inspect(); });
  document.addEventListener('submit', event => {
    if (event.target.querySelector?.('input[name="language_code"]')) write(changeKey, Date.now());
  }, true);
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; inspect(); });
  });
  observer.observe(document.body, {childList:true, subtree:true});
  if (prompt) new MutationObserver(inspect).observe(prompt, {attributes:true, attributeFilter:['open','data-status','data-switching']});
  setInterval(inspect, 250);
  inspect();
})();
